import {
  UpdateNotificationSegment,
  UpdateNotificationSegmentVariables
} from './__generated__/UpdateNotificationSegment'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UpdateNotificationSegment($input: UpdateNotificationSegmentInputV2!) {
    updateNotificationSegment: updateNotificationSegmentV2(input: $input) {
      ... on NotificationSegmentV2 {
        id
        title
        isDynamic
        dynamicUrl
      }
    }
  }
`

export const useUpdateNotificationSegment = () =>
  useMutation<UpdateNotificationSegment, UpdateNotificationSegmentVariables>(MUTATION)
